import { render, staticRenderFns } from "./VirtualAssistantEventsSummary.vue?vue&type=template&id=0162303f&scoped=true&"
import script from "./VirtualAssistantEventsSummary.vue?vue&type=script&lang=js&"
export * from "./VirtualAssistantEventsSummary.vue?vue&type=script&lang=js&"
import style0 from "./VirtualAssistantEventsSummary.vue?vue&type=style&index=0&id=0162303f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0162303f",
  null
  
)

export default component.exports